<template>
    <v-dialog v-model="dialogedituser" attach="#main-layout" transition="none" max-width="340" content-class="right-modal" scrollable>
    <v-card class="pa-0" style="border-radius:12px; overflow-y:auto; max-height:calc(100vh - 64px); display:flex; flex-direction:column;">
      <v-card-title class="headline white--text d-flex align-center" style="background: #003871; padding: 10px 24px;">
        <v-spacer></v-spacer>
        <v-icon color="white" class="mr-2">mdi-account-edit</v-icon>
        <span class="text-subtitle-2">EDIT KPI USER</span>
        <v-spacer></v-spacer>
        <v-btn icon dark @click="dialogedituser = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      
      <v-card-text class="pa-0 mt-4">
        <v-row no-gutters>
          <!-- Kolom Kiri: Form Utama -->
          <v-col cols="12" md="12" class="pa-4">
            <v-form ref="form">
              <v-text-field
                v-model="localNode.position_name"
                label="Position Name *"
                dense
                outlined
                :rules="[v => !!v || 'Position name is required']"
                :disabled="!getEditableStatus()"
              />
              
              <v-textarea
                v-model="localNode.notes"
                label="Notes"
                dense
                outlined
                rows="4"
                class="mb-1"
                :disabled="!getEditableStatus()"
              />
              
              <!-- Assign User: tampilan saat user kosong -->
              <div v-if="isUserEmpty" class="mb-3">
                <div class="text-caption grey--text mb-1">Assign User</div>
                <v-card outlined class="pa-3 mb-2" style="background-color: #f5f5f5;">
                  <div class="d-flex align-center">
                    <v-icon color="grey" class="mr-2">mdi-account</v-icon>
                    <div>
                      <div class="text-body-2 font-weight-medium grey--text text--darken-1">Belum Ada User</div>
                      <div class="text-caption grey--text">{{ emptySinceText }}</div>
                    </div>
                    <v-spacer></v-spacer>
                    <v-btn color="orange" small @click="onAssignUser" >
                      <v-icon left small>mdi-plus</v-icon>
                      Assign User
                    </v-btn>
                    <!-- <v-chip x-small color="warning" text-color="white">Kosong</v-chip> -->
                  </div>
                </v-card>
              </div>
              <!-- Assign User: tampilan saat user sudah ada -->
              <template v-else>
                <!-- Published (status_publish === 1): card + Mutasi -->
                <div v-if="userHistories.length > 0" class="mb-3">
                  <div class="text-caption grey--text mb-1">Assign User</div>
                  <v-card outlined class="pa-3 mb-2" style="background-color: #e3f2fd;">
                    <div class="d-flex align-center">
                      <v-avatar color="primary" size="40" class="mr-3">
                        <span class="white--text text-caption">
                          {{ getInitials(localNode.user?.name || localNode.user_name) }}
                        </span>
                      </v-avatar>
                      <div class="flex-grow-1">
                        <div class="font-weight-bold">{{ localNode.user?.name || localNode.user_name || "—" }}</div>
                        <div class="text-caption grey--text">
                          Mulai: {{ formatHistoryMonth(localNode.active_history?.start_month) }}
                        </div>
                      </div>
                      <v-btn
                        color="orange"
                        small
                        @click="onAssignUser"
                        v-if="currentUser && currentUser.role !== 'user'"
                      >
                        <v-icon left small>mdi-sync</v-icon>
                        Mutasi
                      </v-btn>
                      <!-- <v-chip x-small color="grey" dark>Terkunci</v-chip> -->
                    </div>
                  </v-card>
                  <!-- <v-alert dense type="warning" outlined class="mb-2">
                    <div class="d-flex align-center">
                      <v-icon left color="warning">mdi-alert</v-icon>
                      <span>Posisi sudah publish. Ganti user lewat Mutasi.</span>
                      <v-spacer></v-spacer>
                      <v-btn color="orange" small @click="onAssignUser">
                        <v-icon left small>mdi-sync</v-icon>
                        Mutasi
                      </v-btn>
                    </div>
                  </v-alert> -->
                </div>
                <!-- Not published: v-select -->
                <v-select
                  v-else
                  v-model="localNode.user_id"
                  :items="users"
                  item-text="text"
                  item-value="value"
                  label="Assign User"
                  :disabled="!getEditableStatus()"
                  dense
                  outlined
                  clearable
                  class="mb-3"
                />
              </template>

              <!-- Riwayat Jabatan (timeline style) -->
              <v-expansion-panels v-if="userHistories.length > 0 " v-model="riwayatExpanded" class="mb-3">
                <v-expansion-panel>
                  <v-expansion-panel-header class="py-2" style="min-height: 36px;">
                    <span class="text-caption" style="font-size: 11px;">Riwayat Jabatan ({{ userHistories.length }} entri)</span>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content class="pa-2 pt-0">
                    <div class="riwayat-timeline">
                      <div
                        v-for="(entry, idx) in userHistories"
                        :key="entry.id"
                        class="riwayat-timeline-item"
                      >
                        <div class="riwayat-timeline-marker">
                          <div class="riwayat-timeline-dot"></div>
                          <div v-if="idx < userHistories.length - 1" class="riwayat-timeline-line"></div>
                        </div>
                        <div class="riwayat-timeline-content">
                          <v-card
                            outlined
                            class="riwayat-card"
                          >
                            <div class="d-flex align-start">
                              <div class="flex-grow-1" style="min-width: 0;">
                                <div class="font-weight-medium riwayat-name">{{ entry.user_name || "Posisi kosong" }}</div>
                                <div class="riwayat-date">
                                  {{ formatHistoryMonth(entry.start_month) }}
                                  —
                                  <span v-if="entry.end_month">{{ formatHistoryMonth(entry.end_month) }}</span>
                                  <span v-else class="success--text">Sekarang</span>
                                </div>
                                <div v-if="entry.notes" class="riwayat-notes">{{ entry.notes }}</div>
                              </div>
                              <v-btn
                                v-if="userHistories.length > 1 && idx === 0 && (currentUser && currentUser.role !== 'user')"
                                icon
                                x-small
                                class="riwayat-delete-btn"
                                @click="confirmDeleteHistory(entry)"
                              >
                                <v-icon x-small>mdi-delete</v-icon>
                              </v-btn>
                            </div>
                          </v-card>
                        </div>
                      </div>
                    </div>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>

              <v-select
                v-model="localNode.chart_parent_id"
                :items="reportToList"
                item-text="position_name"
                item-value="id"
                label="Report To"
                :disabled="!getEditableStatus()"
                dense
                outlined
                class="mb-4"
              />
              
              <!-- Tombol Delete dan Save -->
              <div class="d-flex justify-end mb-5">
                <v-btn 
                  color="error" 
                  @click="deleteChartUser" 
                  class="mr-12" 
                  style="width: 120px"
                  :disabled="!getEditableStatus()"
                  small
                >
                  <v-icon left small>mdi-delete</v-icon>
                  Delete
                </v-btn>
                <v-btn 
                  color="primary" 
                  @click="saveEditUser"
                  style="width: 120px"
                  :disabled="!getEditableStatus()"
                  small
                >
                  <v-icon left small>mdi-content-save</v-icon>
                  Save
                </v-btn>
              </div>
            </v-form>
            <!-- <v-btn 
              small 
              color="success"
              @click="openDetail()" 
              class="mt-2"
              block
            >
              <v-icon left>mdi-cog</v-icon>
              Setting KPI
            </v-btn> -->
            <v-btn 
            small 
            color="success"
            @click="openDetail()" 
            class="mt-2"
            block
            large
            :disabled="getKpiButtonStatus()"
            :loading="settingKpiLoading[selectedNode.id]"
            >
            <v-icon left>mdi-cog</v-icon>
            {{ getKpiButtonText() }}
            </v-btn>
            <v-btn
              small
              color="orange darken-2"
              :dark="Number(selectedNode.status_publish) === 2"
              @click="openAccountingTarget()"
              class="mt-2"
              block
              large
              :disabled="Number(selectedNode.status_publish) !== 2"
            >
              <v-icon left>mdi-calculator-variant</v-icon>
              Adjust Accounting
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <!-- Modal Konfirmasi Delete User -->
    <v-dialog v-model="deleteDialog" max-width="400px">
      <v-card>
        <v-card-title class="headline error--text">
          <v-icon left color="error">mdi-alert-circle</v-icon>
          Confirm Delete
        </v-card-title>
        <v-card-text class="pa-4">
          Are you sure you want to delete this User? This action cannot be undone.
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="deleteDialog = false">
            Cancel
          </v-btn>
          <v-btn color="error" @click="confirmDelete">
            <v-icon left>mdi-delete</v-icon>
            Delete
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Modal Konfirmasi Delete Riwayat Jabatan -->
    <v-dialog v-model="deleteHistoryDialog" max-width="400px">
      <v-card>
        <v-card-title class="headline error--text">
          <v-icon left color="error">mdi-alert-circle</v-icon>
          Hapus Riwayat Jabatan
        </v-card-title>
        <v-card-text class="pa-4">
          Yakin ingin menghapus riwayat jabatan ini? Tindakan ini tidak dapat dibatalkan.
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="closeDeleteHistoryDialog">
            Batal
          </v-btn>
          <v-btn color="error" @click="deleteHistoryConfirmed">
            <v-icon left>mdi-delete</v-icon>
            Hapus
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Modal Assign User -->
    <v-dialog v-model="assignUserDialog" max-width="480" persistent>
      <v-card>
        <div class="orange white--text pa-4">
          <div class="d-flex align-center">
            <v-icon class="mr-2">mdi-account-plus</v-icon>
            <span class="text-subtitle-1 font-weight-medium">Assign User</span>
            <v-spacer></v-spacer>
            <v-btn icon dark @click="closeAssignUserDialog">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </div>
          <div class="d-flex align-center ml-8">
            <div class="text-caption mt-1" style="opacity: 0.9;">
              {{ localNode.position_name || "—" }}
            </div>
          </div>
        </div>

        <!-- Stepper -->
        <v-stepper v-model="assignUserStep" flat class="transparent">
          <v-stepper-header class="px-4">
            <v-stepper-step :complete="assignUserStep > 1" :step="1" color="orange">
              Isi Data
            </v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step :step="2" color="orange">
              Konfirmasi
            </v-stepper-step>
          </v-stepper-header>

          <v-stepper-items>
            <!-- Step 1: Isi Data -->
            <v-stepper-content :step="1">
              <v-card flat class="pa-4">
                <v-alert
                  v-if="assignUserValidationError"
                  dense
                  type="error"
                  outlined
                  class="mb-3"
                  icon="mdi-alert-circle"
                >
                  Pilih user yang akan di-assign.
                </v-alert>
                <v-autocomplete
                  v-model="assignUserForm.user_id"
                  :items="users"
                  item-text="text"
                  item-value="value"
                  label="User yang Akan Di-assign"
                  placeholder="-- Pilih User --"
                  dense
                  outlined
                  clearable
                  class="mb-3"
                  hide-details
                />
                <v-select
                  v-model="assignUserForm.start_month"
                  :items="monthOptions"
                  item-text="label"
                  item-value="value"
                  label="User baru mulai bulan *"
                  placeholder="-- Pilih Bulan --"
                  dense
                  outlined
                  clearable
                  class="mb-3"
                  hide-details
                />
                <v-textarea
                  v-model="assignUserForm.description"
                  label="Keterangan / Alasan"
                  placeholder="Misal: Resign, Transfer, Promosi..."
                  dense
                  outlined
                  rows="3"
                  hide-details
                />
              </v-card>
              <div class="d-flex justify-space-between pa-4 pt-0">
                <v-btn text @click="closeAssignUserDialog">Batal</v-btn>
                <v-btn color="orange" @click="assignUserLanjut">
                  Lanjut
                  <v-icon right small>mdi-arrow-right</v-icon>
                </v-btn>
              </div>
            </v-stepper-content>

            <!-- Step 2: Konfirmasi -->
            <v-stepper-content :step="2">
              <v-card flat class="pa-4">
                <v-alert type="success" outlined dense class="mb-3">
                  <div class="d-flex align-center">
                    <!-- <v-icon color="success" class="mr-2">mdi-check-circle</v-icon> -->
                    <div>
                      <div class="font-weight-bold success--text">Konfirmasi Assign User</div>
                      <div class="text-caption grey--text">Pastikan data sudah benar.</div>
                    </div>
                  </div>
                </v-alert>
                <v-card outlined class="pa-3 mb-3" style="background-color: #f1f8e9;">
                  <div class="d-flex align-start">
                    <v-icon color="success" class="mr-2">mdi-sync</v-icon>
                    <div>
                      <div class="text-caption grey--text">USER DI-ASSIGN</div>
                      <div class="font-weight-bold">{{ assignUserSelectedName }}</div>
                      <div class="text-caption">Efektif: {{ assignUserMonthLabel }}</div>
                    </div>
                  </div>
                </v-card>
                <v-card v-if="assignUserForm.description" outlined class="pa-3" style="background-color: #fafafa;">
                  <div class="d-flex align-center">
                    <v-icon small class="mr-2 grey--text">mdi-pencil</v-icon>
                    <span class="text-body-2">{{ assignUserForm.description }}</span>
                  </div>
                </v-card>
              </v-card>
              <div class="d-flex justify-space-between pa-4 pt-0">
                <v-btn text @click="assignUserStep = 1">
                  <v-icon left small>mdi-arrow-left</v-icon>
                  Kembali
                </v-btn>
                <v-btn color="primary" @click="assignUserConfirm">
                  <v-icon left small>mdi-check</v-icon>
                  Konfirmasi
                </v-btn>
              </div>
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
      </v-card>
    </v-dialog>
  </v-dialog>
</template>
<script>
export default {
	props: {
		value: Boolean,
		selectedNode: Object,
		users: Array,
		reportToList: Array,
	},
	emits: ["input", "submitted", "snackbar"],
	data() {
		return {
			deleteDialog: false,
			periodList: [],
			deletePeriodDialog: false,
			periodToDelete: null,
			showAddPeriodModal: false,
			startDateMenu: false,
			settingKpiLoading: {},
			chartStatus: null,
			newPeriod: {
				start_month: "",
				end_month: "",
			},
			localNode: {
				user_id: null,
				user_parent_id: null,
				chart_parent_id: null,
				position_name: "",
				notes: "",
				position_description: "",
			},
			assignUserDialog: false,
			assignUserStep: 1,
			assignUserValidationError: false,
			assignUserForm: {
				user_id: null,
				start_month: "",
				description: "",
			},
			deleteHistoryDialog: false,
			historyToDelete: null,
			riwayatExpanded: 0,
		};
	},

	watch: {
		selectedNode: {
			handler(newVal) {
				if (!newVal) return;
				this.localNode = {
					user_id: Number(newVal?.user_id ?? newVal?.user?.id ?? null),
					chart_parent_id: newVal?.chart_parent_id ?? null,
					position_name: newVal?.position_name ?? "",
					notes: newVal.position_description ?? "",
					...newVal,
				};
				this.loadPeriodsFromNode(newVal);
			},
			deep: true,
			immediate: true,
		},
	},
	computed: {
		dialogedituser: {
			get() {
				return this.value;
			},
			set(val) {
				this.$emit("input", val);
			},
		},
		isUserEmpty() {
			return !this.localNode.user_id && !this.selectedNode?.user;
		},
		emptySinceText() {
			const emptySince = this.selectedNode?.empty_since;
			if (emptySince) {
				const [year, month] = emptySince.split("-");
				const monthNames = [
					"Jan",
					"Feb",
					"Mar",
					"Apr",
					"Mei",
					"Jun",
					"Jul",
					"Agu",
					"Sep",
					"Okt",
					"Nov",
					"Des",
				];
				return `Posisi kosong sejak ${
					monthNames[parseInt(month, 10) - 1] || ""
				} ${year || ""}`;
			}
			return "Posisi kosong";
		},
		monthOptions() {
			const period = this.selectedNode?.active_period;
			const options = [];
			const monthNames = [
				"Jan",
				"Feb",
				"Mar",
				"Apr",
				"Mei",
				"Jun",
				"Jul",
				"Agu",
				"Sep",
				"Okt",
				"Nov",
				"Des",
			];

			if (period && period.start_month && period.end_month) {
				const [startYear, startMonth] = period.start_month.split("-");
				const [endYear, endMonth] = period.end_month.split("-");

				let current = new Date(
					Number(startYear),
					Number(startMonth) - 1,
					1
				);
				const end = new Date(Number(endYear), Number(endMonth) - 1, 1);

				while (current <= end) {
					const y = current.getFullYear();
					const m = String(current.getMonth() + 1).padStart(2, "0");
					options.push({
						value: `${y}-${m}`,
						label: `${monthNames[current.getMonth()]} ${y}`,
					});
					current.setMonth(current.getMonth() + 1);
				}
			}

			return options;
		},
		assignUserSelectedName() {
			if (
				this.assignUserForm.user_id == null ||
				this.assignUserForm.user_id === ""
			) {
				return "Posisi kosong";
			}
			const user = this.users?.find(
				(u) => u.value === this.assignUserForm.user_id
			);
			return user?.text || "—";
		},
		assignUserMonthLabel() {
			const opt = this.monthOptions.find(
				(o) => o.value === this.assignUserForm.start_month
			);
			return opt?.label || "—";
		},
		userHistories() {
			const list =
				this.localNode.user_histories ||
				this.selectedNode?.user_histories ||
				[];
			const arr = Array.isArray(list) ? list : [];
			return [...arr].reverse();
		},
		currentUser() {
			return this.$store.state.user;
		},
	},
	methods: {
		openAccountingTarget() {
			if (!this.selectedNode || !this.selectedNode.id) return;
			this.dialogedituser = false;
			this.$router.push(`/home/accounting-target/${this.selectedNode.id}`);
		},
		formatHistoryMonth(ym) {
			if (!ym) return "—";
			const [y, m] = String(ym).split("-");
			const names = [
				"Jan",
				"Feb",
				"Mar",
				"Apr",
				"Mei",
				"Jun",
				"Jul",
				"Agu",
				"Sep",
				"Okt",
				"Nov",
				"Des",
			];
			return `${names[parseInt(m, 10) - 1] || ""} ${y || ""}`;
		},
		getInitials(name) {
			if (!name) return "?";
			return name
				.split(" ")
				.map((s) => s[0])
				.join("")
				.toUpperCase()
				.slice(0, 2);
		},
		closeDeleteHistoryDialog() {
			this.deleteHistoryDialog = false;
			this.historyToDelete = null;
		},
		confirmDeleteHistory(entry) {
			this.historyToDelete = entry;
			this.deleteHistoryDialog = true;
		},
		async deleteHistoryConfirmed() {
			if (!this.historyToDelete) return;
			try {
				this.$store.dispatch("setOverlay", true);
				await this.$axios.delete(
					`${process.env.VUE_APP_URL}/api/chart-mutasi/${this.historyToDelete.id}`,
					{
						headers: {
							Authorization: `Bearer ${this.$store.getters.isTokenUser}`,
						},
					}
				);
				this.$emit("snackbar", {
					color: "success",
					icon: "mdi-check-circle",
					timeout: 3000,
					title: "Success",
					text: "Riwayat jabatan berhasil dihapus",
				});
				this.deleteHistoryDialog = false;
				this.historyToDelete = null;
				await this.refreshChartDetail();
				this.$emit("submitted");
			} catch (err) {
				this.$emit("snackbar", {
					color: "error",
					icon: "mdi-alert-circle",
					timeout: 5000,
					title: "Error",
					text: err.response?.data?.message || "Gagal menghapus riwayat",
				});
			} finally {
				this.$store.dispatch("setOverlay", false);
			}
		},
		onAssignUser() {
			this.assignUserForm = { user_id: null, start_month: "", description: "" };
			this.assignUserStep = 1;
			this.assignUserValidationError = false;
			this.assignUserDialog = true;
		},
		closeAssignUserDialog() {
			this.assignUserDialog = false;
			this.assignUserForm = { user_id: null, start_month: "", description: "" };
			this.assignUserStep = 1;
			this.assignUserValidationError = false;
		},
		assignUserLanjut() {
			if (!this.assignUserForm.start_month) {
				this.$emit("snackbar", {
					color: "warning",
					icon: "mdi-alert-circle",
					timeout: 3000,
					title: "Peringatan",
					text: "Pilih bulan mulai.",
				});
				return;
			}
			this.assignUserValidationError = false;
			this.assignUserStep = 2;
		},
		async assignUserConfirm() {
			try {
				this.$store.dispatch("setOverlay", true);
				await this.$axios.post(
					`${process.env.VUE_APP_URL}/api/chart-mutasi`,
					{
						chart_id: this.localNode.id,
						new_user_id: this.assignUserForm.user_id,
						start_month: this.assignUserForm.start_month,
						notes: this.assignUserForm.description || "",
					},
					{
						headers: {
							Authorization: `Bearer ${this.$store.getters.isTokenUser}`,
							"Content-Type": "application/json",
						},
					}
				);
				this.closeAssignUserDialog();
				this.$emit("snackbar", {
					color: "success",
					icon: "mdi-check-circle",
					timeout: 3000,
					title: "Success",
					text: "User berhasil di-assign",
				});
				await this.refreshChartDetail();
				this.$emit("submitted");
			} catch (err) {
				this.$emit("snackbar", {
					color: "error",
					icon: "mdi-alert-circle",
					timeout: 5000,
					title: "Error",
					text: err.response?.data?.message || "Gagal assign user",
				});
			} finally {
				this.$store.dispatch("setOverlay", false);
			}
		},
		getKpiButtonStatus() {
			if (!this.selectedNode || this.selectedNode.status === undefined) {
				return false;
			}

			const status = this.selectedNode.status;

			return status === 1 || status === 2;
		},
		getEditableStatus() {
			if (
				!this.selectedNode ||
				this.selectedNode.status_publish === undefined
			) {
				return false;
			}

			const status_publish = this.selectedNode.status_publish;

			return status_publish === 0;
		},
		getKpiButtonText() {
			if (!this.selectedNode || this.selectedNode.status === undefined) {
				return "Setting KPI";
			}

			const status = this.selectedNode.status;

			switch (status) {
				case 0:
					return "Setting KPI";
				case 1:
					return "KPI Sudah Diatur";
				case 2:
					return "Setup Periode Dulu";
				default:
					return "Setting KPI";
			}
		},

		async fetchChartStatus() {
			try {
				if (!this.selectedNode || !this.selectedNode.id) {
					return;
				}

				const response = await this.$axios.get(
					`${process.env.VUE_APP_URL}/api/charts/detail/${this.selectedNode.id}`,
					{
						headers: {
							Authorization: `Bearer ${this.$store.getters.isTokenUser}`,
						},
					}
				);

				if (response.data) {
					if (response.data.status !== undefined) {
						this.chartStatus = response.data.status;
						this.$set(this.selectedNode, "status", response.data.status);
					}

					if (response.data.active_period) {
						this.$set(
							this.selectedNode,
							"active_period",
							response.data.active_period
						);
					}
				}
			} catch (error) {
				console.error("Error fetching chart status:", error);
			}
		},

		async openDetail() {
			if (this.getKpiButtonStatus()) {
				const status = this.selectedNode.status;
				let message = "";

				if (status === 1) {
					message =
						"KPI sudah diatur untuk posisi ini. Button tidak dapat diakses.";
				} else if (status === 2) {
					message =
						"Silakan setup periode terlebih dahulu sebelum mengatur KPI.";
				}

				this.$emit("snackbar", {
					color: "warning",
					icon: "mdi-alert-circle",
					timeout: 5000,
					title: "Peringatan",
					text: message,
				});
				return;
			}

			try {
				this.$set(this.settingKpiLoading, this.selectedNode.id, true);

				const periodData = this.selectedNode.active_period || null;

				this.$emit("open-detail", {
					chart_id: this.selectedNode.id,
					chart_data: this.selectedNode,
					period_data: periodData,
				});
			} catch (error) {
				console.error("❌ Error in openDetail:", error);
				this.$emit("snackbar", {
					color: "error",
					icon: "mdi-alert-circle",
					timeout: 5000,
					title: "Error",
					text: error.message || "Failed to open detail",
				});
			} finally {
				this.$set(this.settingKpiLoading, this.selectedNode.id, false);
			}
		},
		async refreshChartDetail() {
			try {
				const response = await this.$axios.get(
					`${process.env.VUE_APP_URL}/api/charts/detail/${this.localNode.id}`,
					{
						headers: {
							Authorization: `Bearer ${this.$store.getters.isTokenUser}`,
						},
					}
				);
				this.$emit("update-selected-node", response.data);
				this.loadPeriodsFromNode(response.data);
			} catch (err) {
				console.error("Refresh chart detail error:", err);
			}
		},
		resetNodeColors() {
			document.querySelectorAll("[data-n-id]").forEach((el) => {
				el.classList.remove("selected-node");
			});
		},
		formatDate(date) {
			if (!date) return "";
			const [year, month] = date.split("-");
			const monthNames = [
				"January",
				"February",
				"March",
				"April",
				"May",
				"June",
				"July",
				"August",
				"September",
				"October",
				"November",
				"December",
			];
			return `${monthNames[parseInt(month) - 1]} ${year}`;
		},
		closeAddPeriodModal() {
			this.showAddPeriodModal = false;
			this.newPeriod = {
				start_month: "",
				end_month: "",
			};
		},
		async addPeriod() {
			if (this.newPeriod.start_month && this.newPeriod.end_month) {
				try {
					this.$store.dispatch("setOverlay", true);

					const payload = {
						chart_id: this.localNode.id.toString(),
						start_month: this.newPeriod.start_month,
						end_month: this.newPeriod.end_month,
					};

					const response = await this.$axios.post(
						`${process.env.VUE_APP_URL}/api/kpi-periode`,
						payload,
						{
							headers: {
								Authorization: `Bearer ${this.$store.getters.isTokenUser}`,
								"Content-Type": "application/json",
							},
						}
					);
					this.periodList.push({
						id: response.data.id,
						start_date: this.newPeriod.start_month,
						end_date: this.newPeriod.end_month,
						chart_id: this.localNode.id,
						user: this.selectedNode.user,
					});
					this.closeAddPeriodModal();

					this.$emit("snackbar", {
						color: "success",
						icon: "mdi-check-circle",
						timeout: 3000,
						title: "Success",
						text: "Period successfully added",
					});
				} catch (err) {
					console.error("Add period error:", err);
					this.$emit("snackbar", {
						color: "error",
						icon: "mdi-alert-circle",
						timeout: 5000,
						title: "Error",
						text: err.response?.data?.message || "Failed to add period",
					});
				} finally {
					this.$store.dispatch("setOverlay", false);
				}
			}
		},
		validateEndDate() {
			if (this.newPeriod.start_month && this.newPeriod.end_month) {
				return (
					this.newPeriod.start_month < this.newPeriod.end_month ||
					"End date must be after start date"
				);
			}
			return true;
		},
		confirmDeletePeriod(period, index) {
			this.periodToDelete = { ...period, index };
			this.deletePeriodDialog = true;
		},

		async deletePeriodConfirmed() {
			if (!this.periodToDelete) return;

			try {
				this.$store.dispatch("setOverlay", true);
				await this.$axios.delete(
					`${process.env.VUE_APP_URL}/api/kpi-periode/${this.periodToDelete.id}`,
					{
						headers: {
							Authorization: `Bearer ${this.$store.getters.isTokenUser}`,
						},
					}
				);
				this.periodList.splice(this.periodToDelete.index, 1);
				this.deletePeriodDialog = false;
				this.periodToDelete = null;
				this.$emit("snackbar", {
					color: "success",
					icon: "mdi-check-circle",
					timeout: 3000,
					title: "Success",
					text: "Period successfully deleted",
				});
			} catch (err) {
				console.error("Delete period error:", err);
				this.$emit("snackbar", {
					color: "error",
					icon: "mdi-alert-circle",
					timeout: 5000,
					title: "Error",
					text: err.response?.data?.message || "Failed to delete period",
				});
			} finally {
				this.$store.dispatch("setOverlay", false);
			}
		},
		loadPeriodsFromNode(node) {
			if (!node?.kpi_periode) {
				this.periodList = [];
				return;
			}
			this.periodList = node.kpi_periode.map((period) => {
				return {
					id: period.id,
					start_date: period.start_month,
					end_date: period.end_month,
					chart_id: period.chart_id,
					user_id: period.user_id,
					status: period.status,
					user: period.user,
				};
			});

			console.log("Final periodList:", this.periodList);
		},
		async loadPeriods() {
			this.loadPeriodsFromNode(this.selectedNode);
		},
		async saveEditUser() {
			this.$store.dispatch("setOverlay", true);
			const formData = new FormData();
			formData.append("position_name", this.localNode.position_name);
			formData.append("position_description", this.localNode.notes);
			formData.append("chart_parent_id", this.localNode.chart_parent_id || "");
			formData.append("user_parent_id", this.localNode.user_parent_id || "");
			formData.append("user_id", this.localNode.user_id || "");

			try {
				await this.$axios.post(
					`${process.env.VUE_APP_URL}/api/charts/${this.localNode.id}`,
					formData,
					{
						headers: {
							Authorization: `Bearer ${this.$store.getters.isTokenUser}`,
							"Content-Type": "multipart/form-data",
						},
					}
				);
				this.$emit("snackbar", {
					color: "success",
					icon: "mdi-check-circle",
					timeout: 3000,
					title: "Success",
					text: "User KPI successfully created",
				});
				this.$emit("submitted");
				setTimeout(() => {
					this.dialogedituser = false;
				}, 1500);
			} catch (err) {
				this.$store.dispatch("setOverlay", false);
				this.$emit("snackbar", {
					color: "error",
					icon: "mdi-alert-circle",
					timeout: 5000,
					title: "Error",
					text: err.response?.data?.message || "Failed to create chart",
				});
			}
		},
		deleteChartUser() {
			this.deleteDialog = true;
			this.$emit("delete-user", this.localNode);
		},
		async confirmDelete() {
			this.$store.dispatch("setOverlay", true);
			try {
				const res = await this.$axios.delete(
					`${process.env.VUE_APP_URL}/api/charts/${this.localNode.id}`,
					{
						headers: {
							Authorization: `Bearer ${this.$store.getters.isTokenUser}`,
						},
					}
				);
				console.log(res);

				this.$emit("snackbar", {
					color: "success",
					icon: "mdi-check-circle",
					timeout: 3000,
					title: "Success",
					text: "User KPI successfully created",
				});
				this.$emit("submitted");
				this.deleteDialog = false;
				setTimeout(() => {
					this.$store.dispatch("setOverlay", false);
					window.location.reload();
				}, 1000);
			} catch (err) {
				console.error("Delete error:", err);
				this.snackbar = {
					color: "error",
					icon: "mdi-alert",
					title: "Error",
					text: "Delete failed.",
					visible: true,
				};
			}
		},
	},
};
</script>
<style scoped>
.period-table {
	border: 2px solid #e0e0e0;
	border-radius: 4px;
}

.period-table >>> th {
	background-color: #003871;
	text: #fff;
	font-weight: 600;
	text-align: center;
}

.period-table >>> td {
	text-align: center;
	padding: 8px 16px;
}

.period-input {
	margin-bottom: 16px;
}

/* Riwayat Jabatan timeline */
.riwayat-timeline {
	padding-left: 0;
}
.riwayat-timeline-item {
	display: flex;
	align-items: flex-start;
	margin-bottom: 4px;
}
.riwayat-timeline-item:last-child {
	margin-bottom: 0;
}
.riwayat-timeline-marker {
	position: relative;
	display: flex;
	flex-direction: column;
	align-items: center;
	width: 12px;
	flex-shrink: 0;
}
.riwayat-timeline-dot {
	width: 6px;
	height: 6px;
	border-radius: 50%;
	background: #4caf50;
	flex-shrink: 0;
}
.riwayat-timeline-line {
	width: 2px;
	flex-grow: 1;
	min-height: 4px;
	background: #4caf50;
	margin-top: 1px;
}
.riwayat-timeline-content {
	flex: 1;
	margin-left: 8px;
	min-width: 0;
}
.riwayat-card {
	background-color: #f1f8e9 !important;
	border: 1px solid #c5e1a5 !important;
	padding: 4px 8px !important;
}
.riwayat-name {
	font-size: 10px !important;
	line-height: 1.2 !important;
}
.riwayat-date {
	font-size: 9px !important;
	color: #4caf50;
	margin-top: 1px !important;
	line-height: 1.2 !important;
}
.riwayat-notes {
	font-size: 9px !important;
	color: #666;
	margin-top: 1px !important;
	line-height: 1.2 !important;
}
.riwayat-delete-btn {
	background-color: #f8bbd0 !important;
	color: #c2185b !important;
	min-width: 20px !important;
	width: 20px !important;
	height: 20px !important;
}
</style>

  